module.exports = __webpack_public_path__ + "f678d7e30675a2934a99954af4e610f7.pdf";